import { render } from "./ProfileTop.vue?vue&type=template&id=eb428452"
import script from "./ProfileTop.vue?vue&type=script&lang=js"
export * from "./ProfileTop.vue?vue&type=script&lang=js"

import "./ProfileTop.vue?vue&type=style&index=0&id=eb428452&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__